import script from "./CoinTrack.vue?vue&type=script&setup=true&lang=js"
export * from "./CoinTrack.vue?vue&type=script&setup=true&lang=js"

import "./CoinTrack.vue?vue&type=style&index=0&id=d45dd6bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d45dd6bc"]])

export default __exports__